module.exports = __webpack_public_path__ + "assets/media/drift_login_splash_subtitle.e709d0fc.svg";